<template>
  <div class="container-fluid">
    <div v-if="error" class="row">
      <div class="col-12 text-center">
        <div class="w-80 alert alert-danger p-4">
          <h4>خطایی رخ داده است دوباره تلاش کنید!</h4>
        </div>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-12 mx-4">
        <button @click="Introducenew()" class="btn btn-success"><i class="fas fa-plus"></i> ثبت امضای دیجیتال جدید</button>
      </div>
      <div class="col-12 text-center">
        <div v-if="SignList.length == 0" class="w-80 m-4 alert alert-info p-4">
          <h4>امضایی برای نمایش وجود ندارد</h4>
        </div>
        <div v-else class="w-80 m-4">
          <div class="row">
            <div v-for="(sign, index) in SignList" :key="index" class="col-12 my-2 rounded border border-right-primary p-2 bg-light">
              <!-- {{ sign }} -->
              <div class="row">
                <div class="col-md-3 col-6">
                  <small>صاحب امضا: </small> <span class="text"> {{ sign.fa_first_name + ' ' + sign.fa_last_name }}</span>
                </div>
                <div class="col-md-3 col-6">
                  <small> کد ملی صاحب امضا: </small><span class="text"> {{ sign.national_code }} </span>
                </div>
                <div class="col-md-2 col-6">
                  <small>وضعیت امضا: </small
                  ><span class="text">
                    <span v-if="sign.certificate_status.trim() == 'PENDING'" class="badge badge-warning"> تکمیل نشده</span>
                    <span v-if="sign.certificate_status.trim() == 'صادر شد'" class="badge badge-success"> ثبت شد</span>
                  </span>
                </div>
                <div class="col-md-2col-6">
                  <small>تاریخ انقضا : </small><span class="text" dir="ltr"> {{ sign.expire_date }} </span>
                </div>
                <div class="col-md-2 col-6">
                  <button @click="CreateSign(sign)" v-if="sign.certificate_status.trim() == 'PENDING'" class="btn btn-warning btn-complete">تکمیل ثبت نام</button>
                  <!-- <button @click="SafteRecieve(sign)" v-if="sign.certificate_status.trim() != 'PENDING'" class="btn btn-success btn-complete mx-1">خرید سفته</button>
                  <button @click="ListSafte(sign)" v-if="sign.certificate_status.trim() != 'PENDING'" class="btn btn-info btn-complete mx-1">لیست سفته</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      SignList: [],
      error: false,
    }
  },
  created() {
    this.GetList()
  },
  methods: {
    GetList() {
      var GetParams = { method: 'GET', action: 'ElectronicSafte/' + this.$session.get('UserInfoNetPa').wwwtblAzaId, arryfildValue: null }
      this.$PostData_netpatoken(GetParams).then((result) => {
        if ((result.status = 'success')) {
          this.error = false
          this.SignList = result.data
        } else {
          this.error = true
        }
      })
    },
    Introducenew() {
      this.$emit('introduceNew', true)
    },
    CreateSign(sign) {
      this.$emit('CompeleteSign', sign)
    },
    SafteRecieve(sign) {
      this.$emit('SafteRecieve', sign)
    },
    SafteRecieve(sign) {
      this.$emit('SafteRecieve', sign)
    },
    ListSafte(sign) {
      this.$emit('ListSafte', sign)
    },
  },
}
</script>
<style scoped>
small {
  font-size: 13px !important;
  font-weight: normal !important;
}
span.text {
  font-size: 12px !important;
  font-weight: bold !important;
}
</style>
